/**
 * Created with JetBrains PhpStorm.
 * User: augustocorvalan
 * Date: 7/23/13
 * Time: 5:03 PM
 */

'use strict';

var _ = require('underscore');
var $ = require('dibs-jquery-shim');
var DC = require('bunsen/helpers/dibsConstants');
var VisitCount = require('../tracking/models/VisitCountModel');

// private static instance for singleton
var _visitorTracking;

//Module to export, VisitorTracking class
var VisitorTracking = module.exports = function () {
    this.model = new VisitCount();
};

require('bunsen/libraries/plugins/jquery.cookie');

// static properties/methods
_.extend(VisitorTracking, {


    /**
     * singleton implementation
     * keeps the visit count from being incremented multiple times per visit,
     * $.publish listeners registered in the constructor will only be fired once
     * @returns {VisitorTracking}
     */
    getInstance: function () {
        if (!_visitorTracking) {
            _visitorTracking = new VisitorTracking();
        }
        return _visitorTracking;
    }
});

// instance properties, methods
_.extend(VisitorTracking.prototype, {

    model: null,
    hasInit: false,

    defaults: {
        delay: 0
    },

    /**
     * init function
     *
     * @return {boolean} - true if called, false if already called
     */
    init: function visitorTrackingInit(options) {
        var self = this;
        var ajax = options && options.ajax !== undefined ? options.ajax : false;
        this.options = _.extend({}, this.defaults, options);

        if (this.hasInit && !ajax) {
            //keeps this from being called more than once
            return false;
        }

        if (!this.hasInit) {
            $.subscribe(DC.pageEventPrefix + ':updated', function () {
                self.init(Object.assign({ajax: true}, options));
            });
        }

        if (!this.isIframe()) {
            this.hasInit = true;

            this.model.increment('totalVisitCount');
            this.model.increment('session');
            this.model.increment('sinceRegPrompt');

            this.model.save();
        }

        if (!this.hasInit) {
            $.subscribe(DC.pageEventPrefix + ':updated', function () {
                self.init(Object.assign({ajax: true}, options));
            });
        }

        return this.hasInit;
    },

    /**
     * is this script currently executing inside an iframe?
     * @returns {boolean}
     */
    isIframe: function () {
        return !!window && (window.self !== window.top);
    },

    isInCheckoutPage: function () {
        return (document && (document.location.href.indexOf('checkout') > -1)) ? true : false;
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/core/VisitorTracking.js
// module id = 2559
// module chunks = 62